import React, { useEffect, useMemo, useState } from "react";

import { Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "./../../hooks/useDataFetch";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthToken } from "./../../store/selectors/AuthSelectors";
import ApiService from "./../../services/AxiosInstance";
import Select from "react-select";
import { formatValue } from "react-currency-input-field";
import Swal from "sweetalert2";

const months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre",
  };

const Settlement = () => {
  const { id, year } = useParams();

  const [yearFilter, setYearFilter] = useState(
    year || new Date().getFullYear().toString()
  );
  const [studentId, setStudentId] = useState();
  const [students, setStudents] = useState([]);
  const token = useSelector(selectAuthToken);

  const [settlement, setSettlement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { postData } = useDataFetch();

  const fetchSettlement = async (sId, y) => {
    const sid = sId || studentId;
    const yr = y || yearFilter;
    if (!sid) return;
    setIsLoading(true);
    try {
      const response = await ApiService.get(`/student/all-liquidation/${sid}/${yr}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSettlement(response.data);
    } catch (error) {
      console.error("Error fetching settlement:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStudents = async (y) => {
    try {
      const response = await ApiService.get("/students", {
        headers: { Authorization: `Bearer ${token}` },
        params: { year: y || yearFilter },
      });
      const data = response.data?.data || [];
      setStudents(
        data.map((e) => ({
          value: e.id,
          label: `${e.identification} - ${e.first_name} ${e.last_name} (${e.level})`,
        }))
      );
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const { mutate: createPay, isLoading: isPostLoading } = postData(
    "/student/approve-cash-payment",
    {},
    {},
    {
      onSuccess: (data) => {
        toast.success(
          `El pago se ha registrado correctamente.`
        );
        fetchSettlement();
      },
    }
  );

  useEffect(() => {
    setStudentId(id);
  }, [id]);

  useEffect(() => {
    fetchSettlement(studentId, yearFilter);
  }, [studentId, yearFilter]);

  useEffect(() => {
    fetchStudents(yearFilter);
  }, [yearFilter]);

  const confirm = (id, student, type) => {
    Swal.fire({
      title: "¿Confirmar Pago?",
      text: `¿Desea marcar el pago de ${type} para el estudiante ${student}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        createPay({ students_cost_id: id });
      }
    });
  };

  const format = (value) =>
    formatValue({
      value: value?.toString(),
      groupSeparator: ".",
      decimalSeparator: ",",
      prefix: "$",
    });

  const selectedStudent = students.find((s) => s?.value == studentId);

  return (
    <Tab.Container defaultActiveKey="all">
      {selectedStudent && (
        <h4 className="mb-3">{selectedStudent.label}</h4>
      )}
      <div className="d-flex gap-5">
        <div style={{ width: 100 }}>
          <select
            className="form-control mb-3"
            value={yearFilter}
            onChange={(e) => setYearFilter(e.target.value)}
          >
            {[2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
              <option
                key={year}
                value={year}
              >
                {year}
              </option>
            ))}
          </select>
        </div>

        <div style={{ flex: 1, marginLeft: "20px" }}>
          <Select
            options={students}
            value={selectedStudent}
            onChange={(selected) => setStudentId(selected?.value)}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                height: 56,
              }),
            }}
          />
        </div>
      </div>

      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center h-[100vh]">
          <p>Cargando...</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table card-table display dataTablesCard dataTable no-footer">
            <thead>
              <tr>
                <th colSpan={7}>Matrícula</th>
              </tr>
              <tr>
                <th>Costo de Matrícula</th>
                <th>Costo del Seguro</th>
                <th>Interes de Mora</th>
                <th>Sub Total</th>
                <th>Total</th>
                <th>Fecha de Pago</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {settlement?.data?.matriculas?.length > 0 ? (
                settlement?.data?.matriculas?.map((e) => (
                  <tr>
                    <td>{format(e.registration_value)}</td>
                    <td>{format(e.sure_value)}</td>
                    <td>{format(e.interest)}</td>
                    <td>{format(e.subtotal)}</td>
                    <td>{format(e.total)}</td>
                    <td>{e?.payment_date ? e.payment_date : "-"}</td>
                    <td>{e.status == 1 ? "APROBADO" : "PENDIENTE"}</td>
                    <td>
                      {e.status != 1 ? (
                        <Button
                          onClick={() => confirm(e.student_cost_id, e.name, "matrícula")}
                          color="success"
                        >
                          Marcar Pago
                        </Button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan={7} className="text-center">
                    Sin datos para mostrar
                  </th>
                </tr>
              )}
            </tbody>
          </table>

          <table className="table card-table display dataTablesCard dataTable no-footer">
            <thead>
              <tr>
                <th colSpan={8}>Mensualidades</th>
              </tr>
              <tr>
                <th>Mes</th>
                <th>Valor Mensualidad</th>
                <th>Valor del Transporte</th>
                <th>Interes de Mora</th>
                <th>Sub Total</th>
                <th>Total</th>
                <th>Fecha de Pago</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {settlement?.data?.mensualidades?.length > 0 ? (
                settlement?.data?.mensualidades?.map((e) => (
                  <tr>
                    <td>{months[e.month]}</td>
                    <td>{format(e.monthly_value)}</td>
                    <td>
                      {e.transport_value ? format(e.transport_value) : "N/A"}
                    </td>
                    <td>{format(e.interest)}</td>
                    <td>{format(e.subtotal)}</td>
                    <td>{format(e.total)}</td>
                    <td>{e?.payment_date ? e.payment_date : "-"}</td>
                    <td>{e.status == 1 ? "APROBADO" : "PENDIENTE"}</td>
                    <td>
                      {e.status == 0 ? (
                        <Button
                          color="success"
                          onClick={() => confirm(e.student_cost_id, e.name, "mensualidad")}
                        >
                          Marcar Pago
                        </Button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan={8} className="text-center">
                    Sin datos para mostrar
                  </th>
                </tr>
              )}
            </tbody>
          </table>

          {settlement?.data?.costos_periodicos ? (
            <table className="table card-table display dataTablesCard dataTable no-footer">
              <thead>
                <tr>
                  <th colSpan={4}>Costos Periódicos</th>
                </tr>
                <tr>
                  <th>Concepto</th>
                  <th>Total</th>
                  <th>Fecha de Pago</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {settlement?.data?.costos_periodicos?.map((e) => (
                  <tr>
                    <td>{e.concept}</td>
                    <td>{format(e.total)}</td>
                    <td>-</td>
                    <td>{e.status == 1 ? "APROBADO" : "PENDIENTE"}</td>
                    <td>
                      {e.status != 1 ? (
                        <Button
                          color="success"
                          onClick={() =>
                            confirm(e.student_cost_id, e.name, "costos periódicos")
                          }
                        >
                          Marcar Pago
                        </Button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>
      )}
    </Tab.Container>
  );
};

export default Settlement;
